import React from 'react';

import usePage from '@dashboard/hooks/usePage';
import getPageTypeLabel from '@dashboard/services/getPageTypeLabel';
import Link from '@dashboard/components/Link';

import PageEditView from '../components/PageEditView';
import { editorSection } from '../pageEditTabs';

import InvoiceSettingsForm from './PageSettings/components/InvoiceSettingsForm';
import NotificationsForm from './PageSettings/components/NotificationsForm';

export const getEmailsSections = ({ page }) => {
  const context = { page };
  const section = path => editorSection('settings', path, context);

  return [
    {
      ...section('/invoices'),
      description: (
        <>
          Customize invoice settings for this page. These settings will override your{' '}
          <Link to="/settings/invoices">default invoice settings</Link>.
        </>
      ),
      helpUrl: '/help/articles/how-to-send-invoices-after-payment#Settings-per-page',
      component: <InvoiceSettingsForm />,
    },
    {
      ...section('/email-notifications'),
      component: <NotificationsForm />,
      width: '2xl',
      description: `Choose which emails you get about this ${getPageTypeLabel(page)}.`,
      helpUrl: '/help/articles/how-do-I-manage-payment-email-notifications',
    },
  ].filter(tab => tab.isVisible(context));
};

const PageEmails = () => {
  const { page } = usePage();

  return <PageEditView tabs={getEmailsSections({ page })} />;
};

export default PageEmails;
